<template>
  
  <b-container>

    <b-row>

      <b-col>
        <p class="display-1" style="text-align:center;">
          
          

          <b-iconstack>
            <b-icon stacked icon="x-diamond-fill" scale="0.75" variant="secondary" style="color:#10486A"/>
            <b-icon stacked icon="check-all" variant="primary"/>
            
          </b-iconstack>
          
          User Agreement
        </p>

        
	      <h3>1. Terms</h3>
        <p>By accessing the website at <a href="https://www.principaltask.com">https://www.principaltask.com</a>, 
        you are agreeing to be bound by this agreement, all applicable laws and regulations, and agree that you 
        are responsible for compliance with any applicable local laws. If you do not agree 
        with any of these terms, you are prohibited from using or accessing this site. The 
        materials contained in this website are protected by applicable copyright and trademark law.</p>
        <h3>2. Use License</h3>
        <ol type="a">
          <li>Permission is granted to temporarily download one copy of the materials (information or software) on Principal Task's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          <ol type="i">
              <li>modify or copy the materials;</li>
              <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
              <li>attempt to decompile or reverse engineer any software contained on Principal Task's website;</li>
              <li>remove any copyright or other proprietary notations from the materials; or</li>
              <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
          </ol>
            </li>
          <li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Principal Task at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li>
        </ol>
        <h3> 3. SMS (Short Messaging Service)</h3>
        <p>By providing your mobile telephone number, you are authorizing Schwenk Technology Group, the operator of Principal Task, to send
          SMS (aka text) messages to that number.  Furthermore, you understand that you are responsible for any and all message and/or data rates
          that your mobile carrier may charge for these messages.</p>
        <h3>4. Task Templates</h3>
        <p>You own the templates that you create.  By publically sharing the template you are granting a free, un-restricted, perpetual license for Principal Task and all of it users to use and modify the template.</p>
        <h3>5. Disclaimer</h3>
        <ol type="a">
          <li>The materials on Principal Task's website are provided on an 'as is' basis. Principal Task makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</li>
          <li>Further, Principal Task does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</li>
        </ol>
        <h3>6. Limitations</h3>
        <p>In no event shall Principal Task or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Principal Task's website, even if Principal Task or a Principal Task authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
        <h3>7. Accuracy of materials</h3>
        <p>The materials appearing on Principal Task's website could include technical, typographical, or photographic errors. Principal Task does not warrant that any of the materials on its website are accurate, complete or current. Principal Task may make changes to the materials contained on its website at any time without notice. However Principal Task does not make any commitment to update the materials.</p>
        <h3>8. Links</h3>
        <p>Principal Task has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Principal Task of the site. Use of any such linked website is at the user's own risk.</p>
        <h3>9. Modifications</h3>
        <p>Principal Task may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
        <h3>10. Governing Law</h3>
        <p>These terms and conditions are governed by and construed in accordance with the laws of South Dakota, USA and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
	

      </b-col>

      

    </b-row>
    

  </b-container>

</template>

<script>



	export default {
    name: 'UserAgreement',
    metaInfo() {
			return {
				title: 'Principal Task | Terms of Service',
				meta: [
					{
						name: 'description',
						content: 'The Terms of Service/User Agreement for Principal Task.'
					}
				]
			}
		},
		components: {
		},
        data() {
          return {
            task: {},
            currentQuote: '',
            currentAuthor: ''
			}
        },
		computed: {
      appTitle: function() {
        return process.env.VUE_APP_ENV_TITLE || 'Principal Task'
      },
		},
		mounted() {
      let quoteIndex = Math.floor(Math.random() * this.quotes.length) + 1  
      this.currentQuote = this.quotes[quoteIndex].quote
      this.currentAuthor = this.quotes[quoteIndex].author

      //////console.log(quoteIndex + ": " + this.currentQuote + " by " + this.currentAuthor)

		},
		methods: {
			login() {
				this.$auth.loginWithRedirect();
			},
			logout() {
				this.$auth.logout({
					returnTo: window.location.origin
				});
			}
		}
	}
</script>

<style>


</style>